import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { DateTime } from "luxon";
import { FieldValues } from "react-hook-form";
import type { DialogProps } from "../misc/DialogProps";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { DateInput } from "../inputs/DateInput";
import { Student, studentsProvider } from "../providers/studentsProvider";
import { postponeDunningProcess } from "../api/backend.api";
import { SaveButton2 } from "../buttons/SaveButton2";
import { Form2 } from "../misc/Form2";
import { formatDate } from "../utils/calendar";

export function PostponeDunningProcessDialog({
  student,
  open,
  onClose,
  onSuccess,
}: DialogProps & { student: Student; onSuccess: () => void }) {
  const submit = async (data: FieldValues) => {
    const postponedUntilDate = data.postponeUntilDate as DateTime;
    await runSafely(
      async () => {
        if (student.dunningProcess) {
          // Postpone the dunning process via Django backend
          await postponeDunningProcess(student.dunningProcess.id, student.id, postponedUntilDate);
        } else {
          // Postpone at student level via NestJS server
          await studentsProvider.update("students", {
            id: student.id,
            previousData: student,
            data: { dunningPostponedUntil: postponedUntilDate },
          });
        }
      },
      {
        errorMessage: `Fehler beim Speichern`,
        successMessage: `Der ${student.dunningProcess ? "Fall für" : "Fahrschüler"} ${student.name} wird bis ${formatDate(postponedUntilDate)} ausgeblendet.`,
        onSuccess,
      },
    );
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Fall zur späteren Bearbeitung speichern</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <Form2 onSubmit={submit}>
        <DialogContent>
          <DateInput
            source="postponeUntilDate"
            label="ausblenden bis"
            helperText="Wähle das Datum, bis zu dem der Fall ausgeblendet werden soll."
          />
        </DialogContent>
        <DialogActions>
          <SaveButton2 />
        </DialogActions>
      </Form2>
    </Dialog>
  );
}
